<script lang="ts">
  import type { PostFiltersSchema } from '$src/utils/api/feed.util';
  import DateRangeDropdown from '$lib/components/common/dropdowns/DateRange.svelte';

  export let detail: PostFiltersSchema['projectTimeline'] = {} as any;
  export let isValid: boolean;

  let _timelineStart: Date;
  let _timelineEnd: Date;

  if (detail.timelineStart) {
    _timelineStart = new Date(detail.timelineStart);
  }

  if (detail.timelineEnd) {
    _timelineEnd = new Date(detail.timelineEnd);
  }

  $: detail.timelineStart = _timelineStart?.toISOString();
  $: detail.timelineEnd = _timelineEnd?.toISOString();

  $: isValid = !!_timelineStart && !!_timelineEnd;
</script>

<DateRangeDropdown
  bind:startDate={_timelineStart}
  bind:endDate={_timelineEnd}
  label="Project timeline"
  caption="Project timeline"
  dropdownAlign="left"
/>
